import React from "react";
import KontaktForm from "./KontaktForm";
import KontaktInfo from "./KontaktInfo";
import { useTranslations } from '../../locales/useTranslations';
import {
  BiCodeAlt,
  BiTransferAlt,
  BiBuildings,
  BiBarChartAlt2,
  BiBot,
} from "react-icons/bi";

const KontaktFormArea = () => {
  const { t } = useTranslations();

  const services = [
    {
      icon: BiCodeAlt,
      label: t('contact_area_services_software'),
    },
    {
      icon: BiTransferAlt,
      label: t('contact_area_services_digitalization'),
    },
    {
      icon: BiBuildings,
      label: t('contact_area_services_consulting'),
    },
    {
      icon: BiBarChartAlt2,
      label: t('contact_area_services_analytics'),
    },
    {
      icon: BiBot,
      label: t('contact_area_services_automation'),
    },
  ];

  return (
    <section id="contact-form" className="contact-area pt-70 pb-100 kontakt-form-area">
      <div className="container">
        <div className="contact-inner kontakt-form-area__inner">
          <div className="row align-items-stretch">
            <div className="col-lg-6 col-md-12">
              <div className="kontakt-form-services">
                <span className="kontakt-form-services__badge">
                  {t('contact_area_badge')}
                </span>
                <h3 className="kontakt-form-services__title">
                  {t('contact_area_title')}
                </h3>
                <p className="kontakt-form-services__intro">
                  {t('contact_area_subtitle')}
                </p>
                <ul className="kontakt-form-services__list">
                  {services.map(({ icon: Icon, label }) => (
                    <li key={label} className="kontakt-form-services__item">
                      <span className="kontakt-form-services__item-icon" aria-hidden="true">
                        <Icon />
                      </span>
                      <span className="kontakt-form-services__item-text">{label}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <KontaktForm />
            </div>
          </div>
          <KontaktInfo />
        </div>
      </div>
    </section>
  );
};

export default KontaktFormArea;
